export const getFullPropertyPath = (baseFieldName: string, property: string) => {
  let localProperty = property;
  let localBaseFieldName = baseFieldName;

  while (localProperty.startsWith("../") && localBaseFieldName.endsWith(".")) {
    //remove last . temporary
    localBaseFieldName = localBaseFieldName.substring(0, localBaseFieldName.length - 1);

    localBaseFieldName = localBaseFieldName.substring(0, localBaseFieldName.lastIndexOf("."));
    localProperty = localProperty.substring(3);

    //add last .
    localBaseFieldName = `${localBaseFieldName}.`;
  }

  return `${localBaseFieldName}${localProperty}`;
};
